import { render, staticRenderFns } from "./PackageCustomization.vue?vue&type=template&id=7a3d1294"
import script from "./PackageCustomization.vue?vue&type=script&lang=js"
export * from "./PackageCustomization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports